import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrophy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 100,
	viewBox: "0 0 100 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_5298_70096)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M50.021 78.7357C65.8913 78.7357 78.7567 65.8703 78.7567 50C78.7567 34.1298 65.8913 21.2644 50.021 21.2644C34.1508 21.2644 21.2854 34.1298 21.2854 50C21.2854 65.8703 34.1508 78.7357 50.021 78.7357Z",
					fill: "#5A8F02"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M51.2882 36.0176L54.9733 43.4838C55.178 43.8995 55.5746 44.1875 56.0332 44.2544L64.2726 45.4521C65.4273 45.6201 65.8884 47.0388 65.0534 47.8537L59.0905 53.665C58.7582 53.9884 58.6066 54.4546 58.6849 54.9119L60.0923 63.1184C60.2894 64.2693 59.0816 65.1461 58.0495 64.6029L50.6792 60.7282C50.2687 60.5122 49.7785 60.5122 49.3692 60.7282L41.9989 64.6029C40.9655 65.1461 39.759 64.2693 39.9561 63.1184L41.3635 54.9119C41.4418 54.4546 41.2902 53.9896 40.9579 53.665L34.995 47.8537C34.1587 47.0388 34.6211 45.6201 35.7758 45.4521L44.0152 44.2544C44.4738 44.1875 44.8705 43.8995 45.0751 43.4838L48.7603 36.0176C49.277 34.9715 50.7689 34.9715 51.2856 36.0176H51.2882Z",
					fill: "#FDED32"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M59.4189 59.2413C50.702 58.5906 43.4442 52.7086 40.7722 44.7244L35.7682 45.452C34.6135 45.6201 34.1524 47.0388 34.9875 47.8536L40.9504 53.6649C41.2826 53.9883 41.4342 54.4545 41.3559 54.9118L39.9485 63.1184C39.7515 64.268 40.9592 65.146 41.9913 64.6028L49.3616 60.7282C49.7722 60.5122 50.2623 60.5122 50.6717 60.7282L58.0419 64.6028C59.0753 65.146 60.2818 64.2693 60.0847 63.1184L59.4202 59.2413H59.4189Z",
					fill: "#F5C02C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.0211 30.7912C49.2189 30.7912 48.5682 30.1406 48.5682 29.3383V26.6929C48.5682 25.8907 49.2189 25.2401 50.0211 25.2401C50.8233 25.2401 51.4739 25.8907 51.4739 26.6929V29.3383C51.4739 30.1406 50.8233 30.7912 50.0211 30.7912Z",
					fill: "#FDED32"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M64.0679 36.4711C63.5007 35.9038 63.5007 34.9841 64.0679 34.4169L65.9389 32.5459C66.5062 31.9787 67.4259 31.9787 67.9931 32.5459C68.5603 33.1131 68.5603 34.0328 67.9931 34.6001L66.1221 36.4711C65.5549 37.0383 64.6352 37.0383 64.0679 36.4711Z",
					fill: "#FDED32"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M69.9841 50.4195C69.9841 49.6173 70.6347 48.9667 71.437 48.9667H74.0824C74.8846 48.9667 75.5352 49.6173 75.5352 50.4195C75.5352 51.2217 74.8846 51.8723 74.0824 51.8723H71.437C70.6347 51.8723 69.9841 51.2217 69.9841 50.4195Z",
					fill: "#FDED32"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M64.3055 64.4664C64.8727 63.8992 65.7924 63.8992 66.3597 64.4664L68.2306 66.3374C68.7979 66.9047 68.7979 67.8244 68.2306 68.3916C67.6634 68.9588 66.7437 68.9588 66.1765 68.3916L64.3055 66.5206C63.7383 65.9534 63.7383 65.0337 64.3055 64.4664Z",
					fill: "#FDED32"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M50.3571 70.3826C51.1593 70.3826 51.8099 71.0332 51.8099 71.8354V74.4808C51.8099 75.283 51.1593 75.9336 50.3571 75.9336C49.5548 75.9336 48.9042 75.283 48.9042 74.4808V71.8354C48.9042 71.0332 49.5548 70.3826 50.3571 70.3826Z",
					fill: "#FDED32"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M36.3102 64.7039C36.8774 65.2711 36.8774 66.1908 36.3102 66.758L34.4392 68.629C33.872 69.1963 32.9523 69.1963 32.385 68.629C31.8178 68.0618 31.8178 67.1421 32.385 66.5749L34.256 64.7039C34.8232 64.1366 35.7429 64.1366 36.3102 64.7039Z",
					fill: "#FDED32"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.3927 50.7556C30.3927 51.5578 29.7421 52.2084 28.9399 52.2084H26.2945C25.4923 52.2084 24.8417 51.5578 24.8417 50.7556C24.8417 49.9533 25.4923 49.3027 26.2945 49.3027H28.9399C29.7421 49.3027 30.3927 49.9533 30.3927 50.7556Z",
					fill: "#FDED32"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M36.0726 36.7086C35.5054 37.2758 34.5857 37.2758 34.0185 36.7086L32.1475 34.8376C31.5802 34.2704 31.5802 33.3507 32.1475 32.7835C32.7147 32.2162 33.6344 32.2162 34.2016 32.7835L36.0726 34.6544C36.6399 35.2217 36.6399 36.1414 36.0726 36.7086Z",
					fill: "#FDED32"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_5298_70096)",
			children: [/* @__PURE__ */ _jsx("mask", {
				id: "mask0_5298_70096",
				style: { maskType: "alpha" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 100,
				height: 100,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
					fill: "#83BB26"
				})
			}), /* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask0_5298_70096)",
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
					fill: "#008DB3"
				}), /* @__PURE__ */ _jsxs("g", {
					clipPath: "url(#clip2_5298_70096)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M49.3925 75.2493H46.2729V85.7985H49.3925V75.2493Z",
							fill: "#EF9615"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M53.192 75.2493H49.4041V85.7985H53.192V75.2493Z",
							fill: "#F5C02C"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M47.1039 72.9328V71.3638C47.1039 69.4605 48.6474 67.917 50.5507 67.917H45.9039C44.0006 67.917 42.4571 69.4605 42.4571 71.3638V72.9328C42.4571 74.8361 44.0006 76.3796 45.9039 76.3796H50.5507C48.6474 76.3796 47.1039 74.8361 47.1039 72.9328Z",
							fill: "#F5C02C"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M50.553 67.917H53.8466C55.7499 67.917 57.2934 69.4628 57.2934 71.3638V72.9328C57.2934 74.8361 55.7476 76.3796 53.8466 76.3796H50.553C48.6497 76.3796 47.1062 74.8338 47.1062 72.9328V71.3638C47.1062 69.4605 48.652 67.917 50.553 67.917Z",
							fill: "#FDED32"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M71.3521 64.8996L70.1939 67.4784C70.1336 67.613 70.0268 67.7198 69.8922 67.7801L67.3135 68.9383C66.8423 69.1495 66.8423 69.8203 67.3135 70.0339L69.8922 71.1921C70.0268 71.2524 70.1336 71.3592 70.1939 71.4938L71.3521 74.0725C71.5634 74.5437 72.2341 74.5437 72.4477 74.0725L73.6059 71.4938C73.6662 71.3592 73.773 71.2524 73.9076 71.1921L76.4864 70.0339C76.9575 69.8226 76.9575 69.1519 76.4864 68.9383L73.9076 67.7801C73.773 67.7198 73.6662 67.613 73.6059 67.4784L72.4477 64.8996C72.2365 64.4285 71.5657 64.4285 71.3521 64.8996Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M25.2347 68.8849L23.8375 72.0021C23.7655 72.1646 23.6355 72.2946 23.4731 72.3665L20.3559 73.7638C19.7849 74.0191 19.7849 74.8292 20.3559 75.0868L23.4731 76.4841C23.6355 76.556 23.7655 76.686 23.8375 76.8485L25.2347 79.9657C25.4901 80.5367 26.3001 80.5367 26.5578 79.9657L27.955 76.8485C28.027 76.686 28.157 76.556 28.3195 76.4841L31.4367 75.0868C32.0076 74.8315 32.0076 74.0214 31.4367 73.7638L28.3195 72.3665C28.157 72.2946 28.027 72.1646 27.955 72.0021L26.5578 68.8849C26.3024 68.3139 25.4924 68.3139 25.2347 68.8849Z",
							fill: "#F5C02C"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M30.7774 55.2765C24.102 51.3887 19.309 45.1055 16.9206 37.1094C15.1357 31.142 15.3098 26.3095 15.3168 26.1075C15.3725 24.7381 16.4982 23.6588 17.8676 23.6588H34.1291V28.7652H20.516C20.6622 30.5083 21.015 33.029 21.8599 35.8073C23.914 42.557 27.7786 47.6216 33.3469 50.8664L30.7774 55.2788V55.2765Z",
							fill: "#FDED32"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M68.8686 55.2765L66.2992 50.8641C71.8674 47.6216 75.732 42.5547 77.7862 35.805C78.631 33.0267 78.9862 30.506 79.1301 28.7629H65.517V23.6565H81.7784C83.1478 23.6565 84.2736 24.7381 84.3293 26.1052C84.3385 26.3072 84.5103 31.142 82.7277 37.1094C80.3393 45.1055 75.5463 51.3887 68.8709 55.2765H68.8686Z",
							fill: "#F5C02C"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M33.6394 51.695V23.689H29.7028V51.695C29.7028 62.9476 38.8246 72.0694 50.0772 72.0694C50.741 72.0694 51.3979 72.0369 52.0455 71.9743C41.7167 70.9832 33.6394 62.2838 33.6394 51.695Z",
							fill: "#EF9615"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M70.4539 51.695V23.689H33.6393V51.695C33.6393 62.2838 41.7167 70.9855 52.0455 71.9743C62.3742 70.9832 70.4516 62.2838 70.4516 51.695H70.4539Z",
							fill: "#F5C02C"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M32.061 25.1582V20.0193C32.061 19.4368 32.5322 18.9656 33.1148 18.9656H26.3837C25.8011 18.9656 25.3299 19.4368 25.3299 20.0193V25.1582C25.3299 25.7408 25.8011 26.212 26.3837 26.212H33.1148C32.5322 26.212 32.061 25.7408 32.061 25.1582Z",
							fill: "#F5C02C"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M73.0582 18.9656H33.1148C32.5328 18.9656 32.061 19.4374 32.061 20.0193V25.1559C32.061 25.7379 32.5328 26.2096 33.1148 26.2096H73.0582C73.6401 26.2096 74.1119 25.7379 74.1119 25.1559V20.0193C74.1119 19.4374 73.6401 18.9656 73.0582 18.9656Z",
							fill: "#FDED32"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0524 58.2567C44.5136 58.2567 38.4045 52.1453 38.4045 44.6088C38.4045 42.4131 38.9268 40.3427 39.8459 38.5044C37.5991 40.9369 36.225 44.1864 36.225 47.7585C36.225 55.2974 42.3364 61.4064 49.873 61.4064C55.2161 61.4064 59.8396 58.3356 62.0795 53.8629C59.5866 56.5647 56.0168 58.2567 52.0501 58.2567H52.0524Z",
							fill: "#C95E22"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M52.0525 58.2567C56.0192 58.2567 59.5867 56.5647 62.0818 53.8629C63.0033 52.0246 63.5232 49.9542 63.5232 47.7585C63.5232 40.2197 57.4118 34.1106 49.8753 34.1106C45.9086 34.1106 42.3411 35.8027 39.8459 38.5044C38.9245 40.3427 38.4045 42.4131 38.4045 44.6088C38.4045 52.1477 44.5159 58.2567 52.0525 58.2567Z",
							fill: "#DC722B"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M50.4834 40.5817L52.2521 44.1654C52.3496 44.3651 52.5399 44.502 52.7604 44.5345L56.7155 45.1101C57.2702 45.1914 57.4907 45.8714 57.0892 46.2637L54.2273 49.0536C54.0672 49.2091 53.9952 49.432 54.0323 49.6525L54.7078 53.5913C54.8029 54.1437 54.2227 54.5638 53.7283 54.3039L50.191 52.4447C49.9937 52.3403 49.7593 52.3403 49.562 52.4447L46.0246 54.3039C45.5279 54.5638 44.95 54.1437 45.0452 53.5913L45.7206 49.6525C45.7577 49.4343 45.6858 49.2091 45.5256 49.0536L42.6637 46.2637C42.2622 45.8738 42.485 45.1914 43.0374 45.1101L46.9925 44.5345C47.213 44.502 47.4034 44.3651 47.5008 44.1654L49.2695 40.5817C49.5179 40.0804 50.2328 40.0804 50.4811 40.5817H50.4834Z",
							fill: "#FDED32"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M54.3851 51.7298C50.2025 51.4165 46.7186 48.5941 45.435 44.762L43.0327 45.1101C42.478 45.1914 42.2575 45.8714 42.659 46.2637L45.5209 49.0536C45.6811 49.2091 45.753 49.432 45.7159 49.6525L45.0405 53.5913C44.9453 54.1437 45.5256 54.5639 46.02 54.3039L49.5573 52.4447C49.7546 52.3403 49.989 52.3403 50.1863 52.4447L53.7236 54.3039C54.2203 54.5639 54.7983 54.1437 54.7031 53.5913L54.3851 51.7298Z",
							fill: "#F5C02C"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M37.9728 25.2348L36.9608 27.4909C36.9074 27.6092 36.8146 27.7021 36.6962 27.7555L34.4401 28.7675C34.027 28.9531 34.027 29.5404 34.4401 29.7261L36.6962 30.7381C36.8146 30.7914 36.9074 30.8843 36.9608 31.0027L37.9728 33.2587C38.1585 33.6719 38.7457 33.6719 38.9314 33.2587L39.9434 31.0027C39.9968 30.8843 40.0896 30.7914 40.208 30.7381L42.4641 29.7261C42.8772 29.5404 42.8772 28.9531 42.4641 28.7675L40.208 27.7555C40.0896 27.7021 39.9968 27.6092 39.9434 27.4909L38.9314 25.2348C38.7457 24.8216 38.1585 24.8216 37.9728 25.2348Z",
							fill: "white"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M48.1878 85.7986H43.3252C42.847 85.7986 42.4571 86.1862 42.4571 86.6667V92.7456H47.3197V86.6667C47.3197 86.1885 47.7074 85.7986 48.1878 85.7986Z",
							fill: "#C95E22"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M56.423 85.7986H48.1878C47.7097 85.7986 47.3198 86.1862 47.3198 86.6667V92.7456H57.2911V86.6667C57.2911 86.1885 56.9035 85.7986 56.423 85.7986Z",
							fill: "#DC722B"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M33.6486 89.2709H62.922C63.7692 89.2709 64.4562 89.9579 64.4562 90.8051V105.405H32.1144V90.8051C32.1144 89.9579 32.8014 89.2709 33.6486 89.2709Z",
							fill: "#87502A"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M36.666 89.2709H65.9394C66.7866 89.2709 67.4736 89.9579 67.4736 90.8051V105.405H35.1318V90.8051C35.1318 89.9579 35.8188 89.2709 36.666 89.2709Z",
							fill: "#A15F32"
						})
					]
				})]
			})]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_5298_70096",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 57.4713,
					height: 57.4713,
					fill: "white",
					transform: "translate(21.2854 21.2644)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_5298_70096",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 100,
					height: 100,
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip2_5298_70096",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 69.0241,
					height: 86.4368,
					fill: "white",
					transform: "translate(15.3098 18.9656)"
				})
			})
		] })
	]
});
export default SvgTrophy;
